import {
  Mark,
  mergeAttributes,
} from '@tiptap/core'

import { mouseoverHandler } from './helpers/mouseoverHandler'

export interface DeletedOptions {
  /**
   * Whether the inserted text is disabled or not.
   * If true, the inserted text will not be clickable.
   * @default false
   */
  disabled?: boolean

  /**
   * Function to call when the deleted text is hovered.
   * It receives the suggestionId of the hovered element.
   */
  onMouseover?: (suggestionId: string, event: MouseEvent) => void
}

/**
 * This extension allows you to mark text as deleted.
 */
export const Deleted = Mark.create<DeletedOptions>({
  name: 'deleted',

  inclusive: false,

  addAttributes() {
    return {
      suggestionId: {
        default: '',
        parseHTML: (element) => {
          return element.getAttribute('data-suggestion-id')
        },
        renderHTML: (attributes) => ({
          'data-suggestion-id': attributes.suggestionId
        })
      }
    }
  },

  addOptions() {
    return {
      onMouseover: (suggestionId: string) => { },
    }
  },

  parseHTML() {
    return [
      {
        tag: 'del',
        priority: 100
      }
    ]
  },

  renderHTML({ HTMLAttributes }) {
    return ['del', mergeAttributes(HTMLAttributes), 0]
  },

  addProseMirrorPlugins() {
    return [
      mouseoverHandler({
        type: this.type,
        nodeName: 'DEL',
        onMouseover: this.options.onMouseover,
      })
    ]
  },
})
